module.exports = __webpack_public_path__ + "img/c6dbd79.jpg";